import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Check, Download } from 'lucide-react';

const SaleConfirmationDialog = ({
  open,
  onOpenChange,
  saleReceipt,
  handleDownloadPDF,
  handleFinish,
  language
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#10B981]">
            <Check className="w-6 h-6" />
            {language === 'fr' ? 'Vente enregistrée!' : 'Sale Recorded!'}
          </DialogTitle>
        </DialogHeader>
        
        {saleReceipt && (
          <div id="receipt-content" className="bg-[#F5F5F4] p-4 rounded-lg font-mono text-sm">
            <h1 className="text-center font-bold text-lg mb-2">SADASkinCare</h1>
            <p className="text-center text-xs text-[#78716C] mb-4">Ticket pour caisse</p>
            
            <div className="border-t border-dashed border-[#D4D4D4] pt-3 mb-3">
              <p><strong>Client:</strong> {saleReceipt.client}</p>
              <p><strong>Date:</strong> {saleReceipt.date}</p>
              <p><strong>Réf:</strong> {saleReceipt.sale_id?.slice(0, 8)}</p>
              <p className="text-[#10B981] font-bold"><strong>Ticket Mediciel:</strong> {saleReceipt.ticket_mediciel}</p>
            </div>
            
            <div className="border-t border-dashed border-[#D4D4D4] py-3 space-y-2">
              {saleReceipt.items.map((item, idx) => (
                <div key={idx} className="flex justify-between">
                  <div className="flex-1">
                    <p className="text-xs truncate">{item.name}</p>
                    {item.emplacement && (
                      <p className="text-xs text-[#78716C]">({item.emplacement})</p>
                    )}
                  </div>
                  <div className="text-right">
                    <p>{item.quantity} x {item.price.toLocaleString('fr-FR')}</p>
                    <p className="font-medium">{(item.price * item.quantity).toLocaleString('fr-FR')} FCFA</p>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="border-t border-dashed border-[#D4D4D4] pt-3">
              <div className="flex justify-between text-lg font-bold">
                <span>TOTAL</span>
                <span>{saleReceipt.total.toLocaleString('fr-FR')} FCFA</span>
              </div>
            </div>
          </div>
        )}
        
        <DialogFooter className="flex-col gap-3 sm:flex-col">
          <Button
            onClick={handleDownloadPDF}
            variant="outline"
            className="w-full"
            data-testid="download-pdf-btn"
          >
            <Download className="w-4 h-4 mr-2" />
            {language === 'fr' ? 'Télécharger le récap (PDF)' : 'Download recap (PDF)'}
          </Button>
          <Button
            onClick={handleFinish}
            className="w-full bg-[#0F172A] hover:bg-[#334155] text-white"
          >
            {language === 'fr' ? 'Terminer' : 'Finish'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaleConfirmationDialog;
